'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('@liveauctioneers/caterwaul-components/lib/button');

var _button2 = _interopRequireDefault(_button);

var _FormattedMessage = require('../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _TermsOfServiceBanner = require('./TermsOfServiceBanner.scss');

var _TermsOfServiceBanner2 = _interopRequireDefault(_TermsOfServiceBanner);

var _throbber = require('@liveauctioneers/caterwaul-components/lib/throbber');

var _throbber2 = _interopRequireDefault(_throbber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tosLink = (0, _jsx3.default)(_link2.default, {
    to: '/termsandconditions',
    target: '_blank',
    rel: 'noopener'
}, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
    id: 'terms_and_conditions'
}));
var privacyLink = (0, _jsx3.default)(_link2.default, {
    to: '/privacy',
    target: '_blank',
    rel: 'noopener'
}, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
    id: 'privacy_policy'
}));
var cookieLink = (0, _jsx3.default)(_link2.default, {
    to: '/cookie-policy',
    target: '_blank',
    rel: 'noopener'
}, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
    id: 'cookie_policy'
}));

var TermsOfServiceBanner = function (_PureComponent) {
    (0, _inherits3.default)(TermsOfServiceBanner, _PureComponent);

    function TermsOfServiceBanner() {
        (0, _classCallCheck3.default)(this, TermsOfServiceBanner);
        return (0, _possibleConstructorReturn3.default)(this, (TermsOfServiceBanner.__proto__ || (0, _getPrototypeOf2.default)(TermsOfServiceBanner)).apply(this, arguments));
    }

    (0, _createClass3.default)(TermsOfServiceBanner, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                submitted = _props.submitted,
                submitConsent = _props.submitConsent;


            return (0, _jsx3.default)('div', {
                className: _TermsOfServiceBanner2.default.banner
            }, void 0, (0, _jsx3.default)('div', {
                className: _TermsOfServiceBanner2.default['banner-inner']
            }, void 0, (0, _jsx3.default)('div', {
                className: _TermsOfServiceBanner2.default.text
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'terms_banner',
                values: { cookieLink: cookieLink, privacyLink: privacyLink, tosLink: tosLink }
            })), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_button2.default, {
                className: _TermsOfServiceBanner2.default.submit,
                tertiary: true,
                onClick: submitConsent
            }, void 0, !submitted ? (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'consent.agree'
            }) : (0, _jsx3.default)(_throbber2.default, {})))));
        }
    }]);
    return TermsOfServiceBanner;
}(_react.PureComponent);

exports.default = TermsOfServiceBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfServiceBanner/TermsOfServiceBanner.js
// module id = bqR5
// module chunks = 60